import { FC, useCallback, useState } from "react";
import { Button, Modal, Space } from "antd";
import { FormattedMessage } from "react-intl";
import { useMatch } from "react-router-dom";
import { ROUTE_PATHS } from "const/paths";

import { usePresalePasswordsField } from "./hooks";
import {
  PresalePasswordsFieldProps,
  PresalePasswordsListFieldValue,
} from "./types";
import PresalePasswordsForm from "./partials/PresalePasswordsForm";
import PresalePasswordsTable from "./partials/PresalePasswordsTable";
import * as Styled from "./styles";
import { PresalePasswordsFormValue } from "./partials/PresalePasswordsForm/types";

const PresalePasswordsField: FC<PresalePasswordsFieldProps> = (props) => {
  const isEditRoute = !!useMatch(ROUTE_PATHS.EventEdit);
  const [displayForm, setDisplayForm] = useState(false);
  const [editIndex, setEditIndex] = useState<number | undefined>(undefined);
  const [editValues, setEditValues] = useState<
    PresalePasswordsListFieldValue | undefined
  >(undefined);
  const { value, onChange } = props;
  const { table, closeModal, openModal, showPresalePasswordsModal } =
    usePresalePasswordsField({
      ...props,
      setDisplayForm,
      setEditIndex,
      setEditValues,
    });

  const submitPresalePassword = useCallback(
    (passwordValues: PresalePasswordsFormValue) => {
      if (onChange) {
        if (editIndex !== undefined && editIndex >= 0 && value) {
          const newValues = [...value];

          newValues[editIndex] = passwordValues;
          onChange(newValues);
        } else if (value && value.length > 0) {
          onChange([...value, passwordValues]);
        } else {
          onChange([passwordValues]);
        }
      }
      setEditIndex(undefined);
      setEditValues(undefined);
    },
    [onChange, value, editIndex]
  );

  return (
    <>
      <Space direction="vertical" style={{ display: "flex" }}>
        <div>
          {value && value.length > 0
            ? `Active Presale Passwords: ${value.length}`
            : ""}
        </div>
        <Button type="primary" disabled={false} onClick={openModal} block>
          <FormattedMessage defaultMessage="Configure Presale Passwords" />
        </Button>
      </Space>
      <Modal
        title={<FormattedMessage defaultMessage="Presale Passwords" />}
        open={showPresalePasswordsModal}
        footer={null}
        width={900}
        onCancel={closeModal}
        destroyOnClose
      >
        {displayForm ? (
          <PresalePasswordsForm
            editValues={editValues}
            onSubmit={submitPresalePassword}
            onClose={() => {
              setDisplayForm(false);
            }}
          />
        ) : (
          <>
            <PresalePasswordsTable {...table} />
            <Styled.ControlButtonsRow style={{ marginTop: "18px" }}>
              <Button
                type="ghost"
                onClick={() => {
                  closeModal();
                }}
                disabled={isEditRoute ? false : undefined}
              >
                <FormattedMessage defaultMessage="Close" />
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  setDisplayForm(true);
                }}
                disabled={isEditRoute ? false : undefined}
              >
                <FormattedMessage defaultMessage="Add New Password" />
              </Button>
            </Styled.ControlButtonsRow>
          </>
        )}
      </Modal>
    </>
  );
};

export default PresalePasswordsField;
